import { AxiosError } from 'axios';
import { Slide, toast } from 'react-toastify';

let toastContainer;

const stripAnsiCodes = (str: string) => {
  // eslint-disable-next-line no-control-regex
  return str.replace(/\u001b\[.*?m/g, '');
};

export const showErrorToast = (error: unknown, message?: string) => {
  const text = stripAnsiCodes(message || '') ?? 'An error occurred. Please try again later.';

  if (!toastContainer || !toast.isActive(toastContainer)) {
    toastContainer = toast(text, {
      type: 'error',
      autoClose: 3000,
      closeButton: true,
      closeOnClick: true,
      transition: Slide,
    });
  } else {
    toast.update(toastContainer, { type: 'error', render: text });
  }
  // eslint-disable-next-line no-console
  console.error(`${text}`, (error as AxiosError)?.response?.data || error);
};
